<template>
  <swiper :options="swiperOption" v-if="swiperList.length > 0" class="swiper">
    <swiperSlide v-for="(item, index) in swiperList" :key="index" class="swiper-slide">
      <img :src="item.coverUrl" class="swiper-img" @click="goArticleList(item)" />
      <div class="swiper-title" @click="goArticleList(item)">{{item.title}}</div>
    </swiperSlide>
  </swiper>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  data() {
    return {
      swiperOption: {
        autoplay: { delay: 3000, disableOnInteraction: false },
        speed: 3000,
        loop: true,
        slidesPerView: 4,
        slidesPerGroup: 1,
        preventClicks: false,
        preventClicksPropagation: false,
        waitForTransition: false
      }
    };
  },
  props: {
    swiperList: Array
  },
  methods: {
    goArticleList(item) {
      this.$http
        .get(`/open/cms/category?filter=id||eq||${item.categoryId}`)
        .then(res => {
          if (res.data.data[0].parentId) {
            this.$http
              .get(
                `/open/cms/category?filter=id||eq||${res.data.data[0].parentId}`
              )
              .then(data => {
                this.$store.commit("eidtBreadcrumb", data.data.data[0].id);
                this.$router.push({
                  name: "articleList",
                  query: {
                    selectMenuId: data.data.data[0].id,
                    type: "article",
                    selectMoreId: res.data.data[0].id,
                    articleId: item.id
                  }
                });
              });
          } else {
            this.$store.commit("eidtBreadcrumb", res.data.data[0].id);
            this.$router.push({
              name: "articleList",
              query: {
                selectMenuId: res.data.data[0].id,
                type: "article",
                articleId: item.id
              }
            });
          }
        });
    }
  },
  components: {
    swiper,
    swiperSlide
  }
};
</script>

<style lang="scss" scoped>
.swiper {
  height: 242px;
  padding: 16px 8px;
  &-slide {
    width: 296px;
    float: left;
    padding: 0 8px;
    text-align: center;
    cursor: pointer;
    &:hover > .swiper-title {
      color: #ff9240 !important;
    }
  }
  &-img {
    width: 280px;
    height: 180px;
    overflow: hidden;
    display: block;
  }
  &-title {
    width: 280px;
    overflow: hidden;
    font-size: 14px;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-top: 10px;
    color: #313233;
  }
}
</style>